import { t } from "../../presentation/adapters/translate/translate";

export class InvalidCredentialsError extends Error {
  constructor() {
    super(t("ERROR_INVALID_CREDENTIALS"));
    this.name = "InvalidCredentialsError";
  }
}
